import { UserData } from '@e3dc-react/shell/Types'
import { isFlowTheme } from 'src/Libs/utils'
import { Installation } from '../models'

/**
 * Checks the ownership of the installation with the passed userData (currentUser)
 * Because of different handling of the AccountIds between the themes, an extra check needs to be done to compare the correct ID for ownership
 * @param installation Installation - checks ownerAccountId
 * @param userData UserData -  User to check the ownership with
 * @param withCompanyId boolean - if set to true, the 'Firmen_ID' is used as a fallback for the ID comparison
 * @returns boolean - is the user the owner of the installation
 */
export const isOwnerOrCompany = (installation?: Installation, userData?: UserData, withCompanyId?: boolean): boolean => {
  if (!installation || !userData) return false
  if (isFlowTheme) {
    return installation?.ownerAccountId === userData?.ssoId
  }
  const ownerId = Number(installation?.ownerAccountId)
  const isOwner = ownerId === userData?.ID
  return withCompanyId ? isOwner || ownerId === userData?.Firmen_ID : isOwner
}
